export function getStoredJSON(key, fallback) {
  try {
    const value = localStorage.getItem(key);
    if (!value) return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function setStoredJSON(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getStoredValue(key, fallback = null) {
  const value = localStorage.getItem(key);
  return value ?? fallback;
}
